import http from './http-common';

class YarnQualityService {
  getAll() {
    return http.get('/yarnQualities');
  }
  getYarnQualitiesForYarnContract() {
    return http.get('/yarnQualities/yarnQualitiesForYarnContract');
  }
  get(id) {
    return http.get(`/yarnQualities/${id}`);
  }
  update(data) {
    console.log('data: ', data);
    return http.put(`/yarnQualities/update`, data);
  }
}

export default new YarnQualityService();
